export const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "pl";
export const defaultCurrencyFormat =
  process.env.NEXT_PUBLIC_DEFAULT_CURRENCY_FORMAT || "pl-PL";
export const defaultCurrency =
  process.env.NEXT_PUBLIC_DEFAULT_CURRENCY || "PLN";
